export default {
    // 查询插件列表
    queryPluginList(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/listPlugins', params, response);
    },
    // 更新插件启动顺序
    updateSortInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/updateSortInfo', params, response);
    },
    // 上传zip文件
    uploadFile(params, response) {
        window.vue.$apiAxios.post('/plugin/upload', params, response);
    },
    // 上传更新zip包
    uploadUpgradeFile(params, response) {
        window.vue.$apiAxios.post('/plugin/uploadUpgrade', params, response);
    },
    // 更新插件
    upgradePlugin(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/upgrade', params, response);
    },
    // 查询已上传未加载的ZIP插件包集合
    listZipPlugins(params, response) {
        window.vue.$apiAxios.get('/plugin/listZipPlugins', params, response);
    },
    // 安装插件
    install(params, response) {
        window.vue.$apiAxios.post('/plugin/install', params, response);
    },
    // 协助插件
    uninstall(params, response) {
        window.vue.$apiAxios.post('/plugin/uninstall', params, response);
    },
    // 设置插件启用/禁用
    setEnable(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/setEnable', params, response);
    },
    // 开启插件
    startPlugins(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/startPlugins', params, response);
    },
    // 停止插件
    stopPlugins(params, response) {
        window.vue.$apiAxios.postRequestBody('/plugin/stopPlugins', params, response);
    },
    // 删除上传未安装的zip包
    deleteZipFile(params, response) {
        window.vue.$apiAxios.get('/plugin/deleteZipFile', params, response);
    }
};
